import { styled } from "@givenwell/stitches";

export const Text = styled("p");
export const Heading = styled("h1", {
  weight: 700,
});
export const Span = styled("span");
